import { render, staticRenderFns } from "./BUWarehouseManagement.vue?vue&type=template&id=d0e48242&scoped=true&"
import script from "./BUWarehouseManagement.vue?vue&type=script&lang=js&"
export * from "./BUWarehouseManagement.vue?vue&type=script&lang=js&"
import style0 from "./BUWarehouseManagement.vue?vue&type=style&index=0&id=d0e48242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e48242",
  null
  
)

export default component.exports